import Vue from 'vue'
import App from './App.vue'
import VueCookies from 'vue-cookies';
import Notifications from 'vue-notification'
import VueMeta from "vue-meta"

require("@/assets/styles/resets.css");
require("@/assets/styles/base.css");

Vue.use(Notifications);
Vue.use(VueMeta);
Vue.use(VueCookies);
VueCookies.config('30d','/','.pilates.com');

Vue.prototype.$assets =
  "https://s3.amazonaws.com/s3.pilates.com/at-home/";

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
